import PropTypes from "prop-types"

const BatchShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  fileUrl: PropTypes.string,
  projectId: PropTypes.string.isRequired,
  documentType: PropTypes.string.isRequired,
  fileSourceFileName: PropTypes.string,
})

export default BatchShape
